import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

import { ExchangeTypeSubscriberForm } from './exchange-type-subscriber.form';

export class ExchangeTypeForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    const typeView = this.typeViewGet();
    viewSet.viewAdd(typeView);
  }

  // View
  private typeViewGet(): CerFormView {
    return new CerFormView({
      mandatory: true,
      viewMetadata: {
        dataApiName: 'ExchangeType',
        name: 'data-udveksling-typer', text: 'Udvekslingstyper',
        primaryKey: 'id',
        allowEdit: true, allowCreate: false, allowDelete: false,
        baseFields: ['id', 'history'],
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'ExchangeTypeSubscription', parentColumn: 'ExchangeType', column: 'id' }}
        ]
      },
      fieldMetadata: [
        { name: 'name', text: 'Navn', required: true }
      ]
    });
  }
}
